import SuccessfulTemp from "../assets/templates/SuccessfulTemp";

const Successful = () => <SuccessfulTemp />;

export default Successful;